module.exports = __webpack_public_path__ + "static/media/beauty.041982b4.png";